import * as React from 'react';

import config from 'js/app/config';
import path from 'js/lib/path';

import { CourseraMetatags } from 'bundles/seo';
import HubPageGoogleSchemaMarkup from 'bundles/shared-articles/components/seo/HubPageGoogleSchemaMarkup';
import { SEO_CONTENT_PAGE_SLUG, getSEOContentTitle } from 'bundles/unified-seo-content-common/constants';
import type { Props as IntermediateProps } from 'bundles/unified-seo-content-common/pages/resource/ResourceMainHubPage';
import type { SEOContentPageType } from 'bundles/unified-seo-content-common/types';

type Props = Pick<IntermediateProps, 'pageData'> & {
  pageType: SEOContentPageType;
};

const CategoryPageSEO = ({ pageData, pageType }: Props) => {
  const { title, introduction, metaTitle, metaDescription } = pageData;

  if (!title || !introduction) {
    return null;
  }

  const hubPageUrl = path.join(config.url.domain, SEO_CONTENT_PAGE_SLUG[pageType]);

  return (
    <React.Fragment>
      <CourseraMetatags
        metaNameAndProperties={{
          title: metaTitle || title,
          ogAndTwitterTitle: metaTitle || title,
          description: metaDescription || introduction,
          disableCourseraDescriptionSuffix: true,
        }}
        hrefLangOverrides={() => []}
      />
      <HubPageGoogleSchemaMarkup
        hubPageUrl={hubPageUrl}
        hubPageName={SEO_CONTENT_PAGE_SLUG[pageType]}
        hubBreadcrumbList={[{ name: getSEOContentTitle(pageType), absoluteUrl: hubPageUrl }]}
      />
    </React.Fragment>
  );
};

export default CategoryPageSEO;
